import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMoonFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M8 1.333a6.667 6.667 0 1 0 6.665 6.531.5.5 0 0 0-.788-.398 3.833 3.833 0 0 1-5.343-5.343.5.5 0 0 0-.398-.788z"
	})
});
export default SvgMoonFilled;
